(function () {
    'use strict';

    angular.module("imApp").factory("valutasService", ['$ihttp', function ($ihttp) {
        let service = {
            listValutaEdits: function (parms) {
                return $ihttp.post({
                    method: 655,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
